import { registryAPI } from '@/providers/apis/registry/registry';
import { sortByProperty } from '@/utils/utils';
import { Vue, Component } from 'vue-property-decorator';
import { Route } from 'vue-router';
import Registry from '@/routers/views/registry/registry.vue';
import { REGISTRY_TABLE_FIELDS , PARTNERS_DATA_TYPE_FIELDS , REGISTRY_TYPE} from '@/utils/constants';
import { partnersAPI } from '@/providers/apis/partners/partners';
import { PartnersModel } from '@/models/partners/partners';
import { PartnerModel } from '@/models/partners/partner';

@Component({
    name: 'partner-registry',
    components: {
        Registry,
      },
})


export default class PartnerRegistry extends Vue {


    // -----------------------------------------------------------
    // Properties
    private providerList: any = [];

    private filterList: any = [];

    private searchTerms: string = '';
    private tableFields: any = [];

    private registryType: string = REGISTRY_TYPE.partnerRegistry;

    private title: string = 'Partner Registry';
    private userType: string = '';

    private isLoading: boolean = false;

    // ---------------------------------------------------------
    // Hooks
    private created() {
        this.userType = this.$access.getUserType();
        this.tableFields = REGISTRY_TABLE_FIELDS.partnerRegistry;
        this.isLoading = true;
        partnersAPI.getPartners().then((response) => {
            this.concatPartnersData(response);
            this.isLoading = false;
          });
    }

    private onSearchItemsText(value: any) {
        this.searchTerms = value;
        this.filterList = [...this.providerList].filter(
            (item: any) => item.partner_name.toLowerCase().startsWith(value.toLowerCase()),
            );
    }


    // ------------------------------------------------------------------------
    // Methods

    private showDeatils(details: any) {
        this.$router.push({path: `${this.$router.currentRoute.path}/${details.partner_id}`});
    }

    private concatPartnersData(response: any) {
        let partnerArray: any = [];
        if (response[PARTNERS_DATA_TYPE_FIELDS.contentDevelopers]
            && response[PARTNERS_DATA_TYPE_FIELDS.contentDevelopers].length > 0) {
            partnerArray = [ ...partnerArray , ...response[PARTNERS_DATA_TYPE_FIELDS.contentDevelopers]];
        }
        if (response[PARTNERS_DATA_TYPE_FIELDS.funders]
            && response[PARTNERS_DATA_TYPE_FIELDS.funders].length > 0) {
            partnerArray = [ ...partnerArray , ...response[PARTNERS_DATA_TYPE_FIELDS.funders]];
        }
        if (response[PARTNERS_DATA_TYPE_FIELDS.integrationPartners]
            && response[PARTNERS_DATA_TYPE_FIELDS.integrationPartners].length > 0) {
            partnerArray = [ ...partnerArray , ...response[PARTNERS_DATA_TYPE_FIELDS.integrationPartners]];
        }
        if (response[PARTNERS_DATA_TYPE_FIELDS.labSchools]
            && response[PARTNERS_DATA_TYPE_FIELDS.labSchools].length > 0) {
            partnerArray = [ ...partnerArray , ...response[PARTNERS_DATA_TYPE_FIELDS.labSchools]];
        }
        if (response[PARTNERS_DATA_TYPE_FIELDS.researchers]
            && response[PARTNERS_DATA_TYPE_FIELDS.researchers].length > 0) {
            partnerArray = [ ...partnerArray , ...response[PARTNERS_DATA_TYPE_FIELDS.researchers]];
        }
        if (response[PARTNERS_DATA_TYPE_FIELDS.schools]
            && response[PARTNERS_DATA_TYPE_FIELDS.schools].length > 0) {
            partnerArray = [ ...partnerArray , ...response[PARTNERS_DATA_TYPE_FIELDS.schools]];
        }
        this.providerList = partnerArray;
        this.filterList = partnerArray;
    }
}
